import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { selectAccountTypesListItems } from "../../../../../../redux/account-types/selector";
import { accountTypes } from "../../../../../../redux/account-types/action";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";

const ManagementAccountTypes = () => {
  const navigate = useNavigate()
	const dispatch = useAppDispatch()
	const result = useSelector(selectCurrent)
  const [pageData, setPageData] = useState(1)
	const { header, footer, currency } = result
    const itemsData = useSelector(selectAccountTypesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name'},
          { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true},
          { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
      
        ]);
      }
      const fetchAccounttypes=()=>{
        dispatch(accountTypes.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,entity:'accountTypes',jsonData:{
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",}}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchAccounttypes()
		
	}, [pageData])
  const additionButtons: any = [
    {
      name: 'Add AccountType',
      callback: () => handleAdd(),
    }
   
   
  ];
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleEdit=(data: any)=>{
        
    navigate(`${data?.Id}`)
  }
  const handleDelete=(data: any)=>{
    dispatch(accountTypes.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/delete`,
      entity: 'accountTypes',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(accountTypes.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,entity:'accountTypes',jsonData:{
      "PageNumber": pageData,
      "PageSize": 10,
      "SortField": "Id",
      "SortOrder": "desc",}}))
  });
  }
	return (
    <>
    {itemsData?.isLoading ? <PageLoader /> : 
		<Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} onEdit={handleEdit} onDelete={handleDelete}
    paginationData={itemsData?.result?.pagination} additionButtons={additionButtons} headingName="Account Types" />
  }
  </>
     
	);
};

export default ManagementAccountTypes;


